enum TextureKeys{

    Balls='balls-images',
    Avatar='profile-pic',
    RockyBG='rocky-bg',
    RockyMan='rocky-man',
    Cards='card-all',
    AI1='ai1',
    AI1BG='ai1-bg',
    AI2='ai2',
    AI2BG='ai2-bg',
    AI3='ai3',
    AI3BG='ai3-bg',
    CardBG='card-bg',
    GreenBtn='green-btn',
    RedBtn='red-btn',
    Flare='flare',

    BG='Bg',
    BGOver='Bg-Ove',
    Left='left-i',
    Right='right-i',
    FakeNor='fake-nor',
    FakeDone='fake-done',
    HomeBtn='home-btn',
    AutoPlay='auto-play1',
    SimplePlay='simple-play',
    RoundRec='round-rec',
    BetHold='bet-hold',
    Plus='plus-1',
    Minus='minus-1',
    BetxBtn1to50='1-50btnx',
    Logo='logo',
    Info='info',
    BoardCardBG='board-card-bg',
    Ranking='ranking',
    CloseRanking='close-rank',
    PlayAgin='play-again',
    AutoPlayU='auto-playu',

}
export default TextureKeys